export enum ContentSection {
  COMUNICADOS = "COMUNICADOS",
  ADMINISTRACAO = "ADMINISTRACAO",
  RELACOES_FAMILIARES = "RELACOES_FAMILIARES",
  REMUNERACAO_DOS_ADMINISTRADORES = "REMUNERACAO_DOS_ADMINISTRADORES",
  ATIVOS_IMOBILIZADOS = "ATIVOS_IMOBILIZADOS",
  ATIVOS_INTANGIVEIS = "ATIVOS_INTANGIVEIS",
  PARTICIPACOES_EM_SOCIEDADES = "PARTICIPACOES_EM_SOCIEDADES",
  FONTES_DE_RECEITA = "FONTES_DE_RECEITA",
  PRINCIPAIS_CLIENTES = "PRINCIPAIS_CLIENTES",
  ENDIVIDAMENTO = "ENDIVIDAMENTO",
  DIVIDENDOS = "DIVIDENDOS",
  DESTAQUES_FINANCEIROS = "DESTAQUES_FINANCEIROS",
  EXECUTIVE_COMPENSATION = "EXECUTIVE_COMPENSATION",
  EXECUTIVE_AND_DIRECTORS = "EXECUTIVE_AND_DIRECTORS",
  CORPORATE_ACTIONS = "CORPORATE_ACTIONS",
  DIVIDENDS = "DIVIDENDS",
}
